import { createContext } from "react";

const LugaresContext = createContext();

export default LugaresContext;
